import './style.scss';
import { Portfolio } from './PortfolioDetails/Portfolio';
import { PortfolioModel } from './PortfolioDetails/PortfolioModel';
import { Slider } from '../../../js/components/Slider/Slider';

export default !function () {
  const wrapper = document.querySelector('.portfolio-v3__wrapper');

  if (!wrapper) {
    return;
  }

  const list = wrapper.querySelector('.portfolio-v3__list');
  const items = list.querySelectorAll('.portfolio-v3__item');
  const controls = wrapper.querySelector('.portfolio-v3__controls');

  const options = {
    wrapper,
    lazy: true,
    settings: {
      loop: false,
      spaceBetween: 8,
      slideClass: 'portfolio-v3__item',
      wrapperClass: 'portfolio-v3__list',
      freeMode: true,

      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesPerView: 2
        },
        1024: {
          spaceBetween: 32,
          slidesPerView: 3,
          slidesPerGroup: 3,
          freeMode: false,

          pagination: {
            el: '.portfolio-v3__current',
            type: 'fraction'
          },
          navigation: {
            nextEl: '.button-arrow--next',
            prevEl: '.button-arrow--prev',
            disabledClass: 'button-arrow--disabled'
          }
        },
      }
    },
    modules: ['pagination', 'navigation', 'freeMode', 'a11y'],
    initCondition: {
      sm: items.length > 3,
      md: items.length > 5,
      lg: items.length > 6,
      xl: items.length > 6
    },
    controls,
    createCallback: () => {
      list.classList.remove('portfolio-v3__list--static');
      list.classList.add('portfolio-v3__list--slider');
    },
    destroyCallback: () => {
      list.classList.add('portfolio-v3__list--static');
      list.classList.remove('portfolio-v3__list--slider');
    }
  };

  new Slider(options).init();

  /* Preview Popup */
  const portfolioModel = new PortfolioModel();
  const blockName = document.querySelector('.portfolio-v3').dataset.blockName ?? 'Блок без названия'

  list.addEventListener('click', (evt) => {
    evt.preventDefault();

    const card = evt.target.closest('.portfolio-v3__item');

    if (card) {
      new Portfolio(card, list, portfolioModel, blockName).init();
      window.$analytics && window.$analytics.push('portfolio-card-click');
    }
  });
}();
